<template>
  <div />
</template>

<script>
export default {
  name: 'glucose-action',
  props: [
    'typeID',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'LAB_RESULT_VIEW',
        id: 'GLUCOSE',
      });
      this.emitter.trigger('process', this.control);
    },
  },
}
</script>

<style scoped>

</style>